import BadgeHotText from './badge-hot-text.webp?file'
import BadgeHot from './badge-hot.webp?file'
import BadgeNewText from './badge-new-text.webp?file'
import BadgeNew from './badge-new.webp?file'
import BadgeTopText from './badge-top-text.webp?file'
import BadgeTop from './badge-top.webp?file'

export const badgeIcons = {
    'badge-hot': BadgeHot,
    'badge-hot-text': BadgeHotText,
    'badge-new': BadgeNew,
    'badge-new-text': BadgeNewText,
    'badge-top': BadgeTop,
    'badge-top-text': BadgeTopText,
}
